import { CardBalance, RidangoReduxAction } from '@ridango/core';
import { tassign } from 'tassign';
import { CardInfoActions } from './card-info.actions';

export const CARD_INFO_STATE_KEY = 'cardInfo';

export interface CardInfoState {
    card_number: string;
    balance: CardBalance;
    start_date: any;
    end_date: any;
    tickets: any[];
    history: any[];
    loading: boolean;

}
export const CARD_INFO_INITIAL_STATE: CardInfoState = {
    card_number: null,
    balance: null,
    start_date: null,
    end_date: null,
    tickets: [],
    history: [],
    loading: false
};

export function cardInfoReducer(
    state: CardInfoState = CARD_INFO_INITIAL_STATE,
    action: RidangoReduxAction
): CardInfoState {
    switch (action.type) {
        case CardInfoActions.SET_CARD_NUMBER:
            return tassign(state, { card_number: action.payload });
        case CardInfoActions.SET_CARD_BALANCE:
            return tassign(state, { balance: action.payload });
        case CardInfoActions.SET_CARD_TICKETS:
            return tassign(state, { tickets: action.payload });
        case CardInfoActions.SET_FROM_DATE:
            return tassign(state, { start_date: action.payload });
        case CardInfoActions.SET_TO_DATE:
            return tassign(state, { end_date: action.payload });
        case CardInfoActions.SET_CARD_HISTORY:
            return tassign(state, { history: action.payload });
        case CardInfoActions.SET_CARD_INFO_LOADING:
            return tassign(state, { loading: action.payload });
    }
    return state;
}

export interface CardInfoPartialStoreState {
    [CARD_INFO_STATE_KEY]: CardInfoState;
}
